export default function NoFilesCell(categoryID) {
    return <tr key={'noFileIn' + categoryID}>
        <td className="pageCVM__singleFile name">
            <span className="disabled" style={{cursor: 'default'}}>{noFileFound}</span>
        </td>
    </tr>;
}